import type { EmbedContext } from "./embed-protocol";

/** ページ情報として URL を渡してよい固定ルート。 */
const GENERAL_PATHS = new Set(["/", "/mcp-setup"]);
/** キャンバスのパス。canvasId の規則は router.tsx と同じにする。 */
const CANVAS_PATH_PATTERN = /^\/c\/([A-Za-z0-9_-]{6,64})\/?$/u;

/**
 * 子（Connect Feedback）へ渡すページ情報を作る。
 *
 * 投稿本文へ添える「どの画面から送ったか」だけを渡す目的なので、URL は
 * 既知のルートから再構成し、クエリ・ハッシュ・入力内容は一切含めない。
 * 既知のルート以外（未知パス・認証コールバック等）では `null` を返す。
 */
export function feedbackPageContext(origin: string, path: string): EmbedContext | null {
  const cleanPath = path.split(/[?#]/u)[0] ?? "";
  if (GENERAL_PATHS.has(cleanPath)) {
    return { url: `${origin}${cleanPath}` };
  }
  const canvasId = CANVAS_PATH_PATTERN.exec(cleanPath)?.[1];
  // 末尾スラッシュ付きで開かれていても、正規化した `/c/<canvasId>` を返す。
  return canvasId === undefined ? null : { url: `${origin}/c/${canvasId}` };
}
